export default "__VITE_ASSET__Cyquvdsj__"